module.exports = __webpack_public_path__ + "img/HCHOppb.d72c1cf6.png";